'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CcdSections = require('./CcdSections');

var _CcdSections2 = _interopRequireDefault(_CcdSections);

var _CcdTopBar = require('./CcdTopBar');

var _CcdTopBar2 = _interopRequireDefault(_CcdTopBar);

var _CcdHeader = require('./CcdHeader');

var _CcdHeader2 = _interopRequireDefault(_CcdHeader);

require('../css/CcdViewerApp.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CcdViewerApp = function (_Component) {
  _inherits(CcdViewerApp, _Component);

  function CcdViewerApp(props) {
    _classCallCheck(this, CcdViewerApp);

    //create enhancedSections from sections
    var _this = _possibleConstructorReturn(this, (CcdViewerApp.__proto__ || Object.getPrototypeOf(CcdViewerApp)).call(this, props));

    var sections = [];
    if (props.sections) sections = props.sections;
    _this.state = {
      enhancedSections: _this.createEnhancedSections(sections)
    };

    //bind this to all the functions
    _this.toggleCollapse = _this.toggleCollapse.bind(_this);
    _this.toggleVisible = _this.toggleVisible.bind(_this);
    _this.print = _this.print.bind(_this);
    _this.moveSection = _this.moveSection.bind(_this);
    _this.resetPreferences = _this.resetPreferences.bind(_this);
    _this.saveUserPreferences = _this.saveUserPreferences.bind(_this);
    _this.loadUserPreferences = _this.loadUserPreferences.bind(_this);
    _this.compareSections = _this.compareSections.bind(_this);
    _this.scrollToSection = _this.scrollToSection.bind(_this);
    _this.clearScrollTo = _this.clearScrollTo.bind(_this);
    _this.createEnhancedSections = _this.createEnhancedSections.bind(_this);
    return _this;
  }

  _createClass(CcdViewerApp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadUserPreferences();
    }

    //TODO Maybe we should do this in CcdViewerAppContainer

  }, {
    key: 'createCustomSections',
    value: function createCustomSections() {
      var customSectionsData = this.props.customSections;
      var customSections = [];
      if (customSectionsData) {
        //careTeam section
        if (customSectionsData.careTeam) {
          var careTeam = {
            code: "careTeam",
            name: "Care Team",
            customSectionContents: customSectionsData.careTeam
          };
          customSections.push(careTeam);
        }
        //contributors section
        if (customSectionsData.contributors) {
          var contributors = {
            code: "contributors",
            name: "Contributors",
            customSectionContents: customSectionsData.contributors
          };
          customSections.push(contributors);
        }
        //inFulfillmentOfs section
        if (customSectionsData.inFulfillmentOfs) {
          var inFulfillmentOfs = {
            code: "inFulfillmentOfs",
            name: "In Fulfillment Of",
            customSectionContents: customSectionsData.inFulfillmentOfs
          };
          customSections.push(inFulfillmentOfs);
        }
        //componentOf section
        if (customSectionsData.componentOf) {
          var componentOf = {
            code: "componentOf",
            name: "Dates",
            customSectionContents: customSectionsData.componentOf
          };
          customSections.push(componentOf);
        }
        //participants section
        if (customSectionsData.participants) {
          var participants = {
            code: "participants",
            name: "Participants",
            customSectionContents: customSectionsData.participants
          };
          customSections.push(participants);
        }
        //authorizations section
        if (customSectionsData.authorizations) {
          var authorizations = {
            code: "authorizations",
            name: "Authorizations",
            customSectionContents: customSectionsData.authorizations
          };
          customSections.push(authorizations);
        }
        //documentationOfs section
        if (customSectionsData.documentationOfs) {
          var documentationOfs = {
            code: "documentationOfs",
            name: "Documentation",
            customSectionContents: customSectionsData.documentationOfs
          };
          customSections.push(documentationOfs);
        }
        //nonXmlBody section
        if (customSectionsData.nonXmlBody) {
          var nonXmlBody = {
            code: "nonXmlBody",
            name: "Notes",
            customSectionContents: customSectionsData.nonXmlBody
          };
          customSections.push(nonXmlBody);
        }
      }
      return customSections;
    }
  }, {
    key: 'createEnhancedSections',
    value: function createEnhancedSections(sections) {
      var customSections = this.createCustomSections();
      var sectionsWithCustomSections = sections.concat(customSections);

      var enhancedSections = sectionsWithCustomSections.map(function (sectionData, index) {
        sectionData.isVisible = true;
        sectionData.isExpanded = true;
        sectionData.shouldScrollTo = false;
        sectionData.id = index;
        return sectionData;
      });
      return enhancedSections;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.sections && nextProps.sections !== this.props.sections) {
        this.setState({
          enhancedSections: this.createEnhancedSections(nextProps.sections)
        });
        this.loadUserPreferences(); //apply user preferences again
      }
    }
  }, {
    key: 'toggleCollapse',
    value: function toggleCollapse(shouldCollapse, sectionID) {
      var nextEnhancedSections = this.state.enhancedSections;
      nextEnhancedSections = this.state.enhancedSections.map(function (sectionData, index) {
        if (sectionID === undefined || sectionID === null || sectionID === sectionData.id) {
          sectionData.isExpanded = !shouldCollapse;
        }
        return sectionData;
      });
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'toggleVisible',
    value: function toggleVisible(isVisible, sectionID) {
      var nextEnhancedSections = this.state.enhancedSections;
      nextEnhancedSections = this.state.enhancedSections.map(function (sectionData, index) {
        if (sectionID === undefined || sectionID === null || sectionID === sectionData.id) {
          sectionData.isVisible = !isVisible;
        }
        return sectionData;
      });
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'scrollToSection',
    value: function scrollToSection(sectionID) {
      var nextEnhancedSections = this.state.enhancedSections;
      nextEnhancedSections = this.state.enhancedSections.map(function (sectionData, index) {
        if (sectionID !== undefined && sectionID !== null && sectionID === sectionData.id) {
          sectionData.shouldScrollTo = true;
        } else {
          sectionData.shouldScrollTo = false;
        }
        return sectionData;
      });
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'clearScrollTo',
    value: function clearScrollTo() {
      var nextEnhancedSections = this.state.enhancedSections;
      nextEnhancedSections = this.state.enhancedSections.map(function (sectionData, index) {
        sectionData.shouldScrollTo = false;
        return sectionData;
      });
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'print',
    value: function print() {
      //Print the window
      window.print();
    }
  }, {
    key: 'moveSection',
    value: function moveSection(direction, id) {
      var nextEnhancedSections = this.state.enhancedSections;
      var sectionToMoveIndex = this.state.enhancedSections.findIndex(function (section, index) {
        return section.id === id;
      });
      var sectionToMove = nextEnhancedSections.splice(sectionToMoveIndex, 1)[0];
      var newIndex = sectionToMoveIndex + direction;
      nextEnhancedSections.splice(newIndex, 0, sectionToMove);
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'resetPreferences',
    value: function resetPreferences() {
      var nextEnhancedSections = this.state.enhancedSections;

      var visibleAndExpandedSections = this.state.enhancedSections.map(function (sectionData, index) {
        sectionData.isVisible = true;
        sectionData.isExpanded = true;
        return sectionData;
      });

      //Sort sections alphabetically
      nextEnhancedSections = visibleAndExpandedSections.sort(function (sectionA, sectionB) {
        var nameA = sectionA.name ? sectionA.name.toUpperCase() : ""; // ignore upper and lowercase
        var nameB = sectionB.name ? sectionB.name.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'saveUserPreferences',
    value: function saveUserPreferences() {
      var sectionPreferencesArray = [];
      this.state.enhancedSections.forEach(function (section, index, array) {
        sectionPreferencesArray.push({ "name": section.code, "visible": section.isVisible, "orderNum": index });
      });
      this.props.saveUserPreferencesCB(sectionPreferencesArray);
    }
  }, {
    key: 'compareSections',
    value: function compareSections(sectionA, sectionB) {
      //First let's see if there is an order preference
      var sectionDataAOrder = this.getOrderNumberPreference(sectionA);
      var sectionDataBOrder = this.getOrderNumberPreference(sectionB);
      if (sectionDataAOrder < sectionDataBOrder) {
        return -1;
      }
      if (sectionDataAOrder > sectionDataBOrder) {
        return 1;
      }
      // if order is equal, let's sort alphabetically
      var nameA = sectionA.name ? sectionA.name.toUpperCase() : ""; // ignore upper and lowercase
      var nameB = sectionB.name ? sectionB.name.toUpperCase() : ""; // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // order and names must be equal
      return 0;
    }
  }, {
    key: 'loadUserPreferences',
    value: function loadUserPreferences() {
      //Sort sections based on preferences
      var nextEnhancedSections = this.state.enhancedSections.sort(this.compareSections);

      //set visibility of each section based on preferences
      nextEnhancedSections.forEach(function (section, index, array) {
        section.isVisible = this.getVisibilityPreference(section);
        section.isExpanded = true;
      }, this);

      //set the state so the sections will rerender
      this.setState({
        enhancedSections: nextEnhancedSections
      });
    }
  }, {
    key: 'getMatchingPreference',
    value: function getMatchingPreference(section) {
      if (this.props.initialUserPreferences && section && section.code) {
        for (var i = 0; i < this.props.initialUserPreferences.length; i++) {
          var sectionName = section.code.toLowerCase();
          var name = this.props.initialUserPreferences[i].name;
          var preferenceItemName = name ? name.toLowerCase() : "";
          if (sectionName && sectionName === preferenceItemName) {
            return this.props.initialUserPreferences[i];
          }
        }
      }
      return null;
    }
  }, {
    key: 'getVisibilityPreference',
    value: function getVisibilityPreference(section) {
      var preference = this.getMatchingPreference(section);
      if (preference && preference.visible !== null) {
        return preference.visible;
      }
      //default to visible
      return true;
    }
  }, {
    key: 'getOrderNumberPreference',
    value: function getOrderNumberPreference(section) {
      var noPreferenceOrderNum = 9999;
      var preference = this.getMatchingPreference(section);
      if (preference && preference.orderNum !== null) {
        return preference.orderNum;
      }
      //we didn't find a match, so let's set this to the end
      return noPreferenceOrderNum;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'ccdViewerAppContainer' },
        _react2.default.createElement(
          'div',
          { className: "ccdViewerApp" + (this.props.isDownloadVersion ? " downloadVersion" : "") },
          _react2.default.createElement(_CcdTopBar2.default, { sectionsArray: this.state.enhancedSections,
            toggleCollapseCB: this.toggleCollapse,
            saveUserPreferencesCB: this.saveUserPreferences,
            toggleVisibleCB: this.toggleVisible,
            moveSectionCB: this.moveSection,
            resetFilterCB: this.resetPreferences,
            printCB: this.print,
            scrollToSectionCB: this.scrollToSection
          }),
          _react2.default.createElement(
            'div',
            { className: 'ccdContent' },
            this.props.demographics && _react2.default.createElement(_CcdHeader2.default, { demographicsData: this.props.demographics }),
            _react2.default.createElement(_CcdSections2.default, { sectionsArray: this.state.enhancedSections,
              moveSectionCB: this.moveSection,
              toggleCollapseCB: this.toggleCollapse,
              clearScrollToCB: this.clearScrollTo
            }),
            _react2.default.createElement(
              'div',
              { className: 'ccdFooter dropShadow' },
              this.props.documentInformation && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Document '
                ),
                this.props.documentInformation.creationDateTime && _react2.default.createElement(
                  'span',
                  { className: 'no-wrap' },
                  'Created: ',
                  this.props.documentInformation.creationDateTime
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' | '
                ),
                this.props.documentInformation.confidentiality && _react2.default.createElement(
                  'span',
                  { className: 'no-wrap' },
                  'Confidentiality: ',
                  this.props.documentInformation.confidentiality
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' | '
                ),
                this.props.documentInformation.docId && _react2.default.createElement(
                  'span',
                  { className: 'no-wrap' },
                  'Id: ',
                  this.props.documentInformation.docId
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' | '
                ),
                this.props.documentInformation.docVersion && _react2.default.createElement(
                  'span',
                  { className: 'no-wrap' },
                  'Version: ',
                  this.props.documentInformation.docVersion
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' | '
                ),
                this.props.documentInformation.title && _react2.default.createElement(
                  'span',
                  { className: 'no-wrap' },
                  'Title: ',
                  this.props.documentInformation.title
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CcdViewerApp;
}(_react.Component);

CcdViewerApp.PropTypes = {
  demographics: _propTypes2.default.object, //JS object with demographics properties
  documentInformation: _propTypes2.default.object, //JS object with documentInformation properties
  sections: _propTypes2.default.array, //array of section objects, a section object has a header and section text
  customSections: _propTypes2.default.object,
  initialUserPreferences: _propTypes2.default.array,
  saveUserPreferencesCB: _propTypes2.default.func, //Parameters: user, sectionlist
  isDownloadVersion: _propTypes2.default.bool
};

exports.default = CcdViewerApp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/CcdViewerApp.js
// module id = 1204
// module chunks = 0